module.exports = __webpack_public_path__ + "static/media/skater4.dc41457d.jpg";